export const FORMAT_HEX = 'hex';
export const FORMAT_RGB = 'rgb';
export const FORMAT_HSB = 'hsb';


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/color-picker/interface.js
// module id = 1828
// module chunks = 0